
















































import { Component, Vue } from 'vue-property-decorator'
import axios from '@/plugins/axios'
import { showHttpErrorAlert } from '@/plugins/helper'

@Component
export default class Login extends Vue {
  username = ''
  password = ''
  isLoading = false

  rules = {
    required: (value: string) => !!value || 'Required field'
  }

  async login (): Promise<void> {
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return
    }

    try {
      this.isLoading = true
      const { data } = await axios.post('/portal/login', {
        username: this.username,
        password: this.password
      })

      await this.$store.dispatch('user/setCurrentUserFromToken', data.access_token)

      this.isLoading = false

      if (this.$store.getters['user/hasRoles'](['admin', 'insurance_partner'])) {
        this.$router.push({ name: 'insurance-partner/view-orders' })
      } else if (this.$store.getters['user/hasRoles'](['admin', 'reward_partner'])) {
        this.$router.push({ name: 'partner-select-shop' })
      } else {
        this.$router.push({ name: 'forbidden' })
      }
    } catch (error) {
      this.isLoading = false
      showHttpErrorAlert(error)
    }
  }
}
